import { api } from "@/lib/api";

export const FIN_TYPES = { CASH: "Peşin", BANK_LOAN: "Banka kredisi", FINANCE_COMPANY: "Finansman şirketi" };
export const DEED_STEPS = { DOCS_READY: "Evrak hazır", FEES_PAID: "Harç ödendi", APPOINTMENT: "Randevu alındı", COMPLETED: "Tapu devri tamamlandı" };
export const today = () => new Date().toISOString().slice(0, 10);
export const addDays = (n) => new Date(Date.now() + n * 864e5).toISOString().slice(0, 10);

export const openBlob = async (url) => {
  const win = window.open("", "_blank");
  try {
    const { data } = await api.get(url, { responseType: "blob" });
    win.location.href = URL.createObjectURL(data);
  } catch {
    win?.close();
  }
};

export const num = (v) => (v === "" || v == null ? null : Number(v));
